import React from 'react'
import styled from 'styled-components'

const Button = styled.a`
  background: ${props => (props.inverse ? '#FFF' : props.theme.colors.rojoBac)};
  border: 2px solid ${props => (props.inverse ? '#FFF' : props.theme.colors.rojoBac)};
  color: ${props => (props.inverse ? props.theme.colors.rojoBac : '#FFF')};
  padding: ${props => (props.smallPadding ? '.4em' : '.8em')};
  display: ${props => (props.fullwidth ? 'block' : 'inline-block')};
  text-decoration: none;
  transition: all 0.2s ease-in;
  border-radius: 3px;
  cursor: pointer;
  text-align: center;
  font-size: ${props => (props.fullwidth ? '20px' : 'inherit')};
  font-weight: ${props => (props.fullwidth ? '700' : '400')};

  &:hover {
    background: #fff;
    color: ${props => props.theme.colors.rojoBac};
    border: 2px solid ${props => props.theme.colors.rojoBac};
    box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
    transition: all 0.2s ease-in;
  }
  &:active {
    background: ${props => (props.inverse ? '#FFF' : props.theme.colors.rojoBac)};
    border: 2px solid ${props => (props.inverse ? '#FFF' : props.theme.colors.rojoBac)};
    color: ${props => (props.inverse ? '#FFF' : props.theme.colors.rojoBac)};
    transform: scale(0.95);
    transition: all 0.2s ease-in;
  }
`

export default ({
  to,
  children,
  inverse,
  fullwidth,
  smallPadding,
  className = null,
  target = null,
}) => (
  <Button
    href={to}
    inverse={inverse}
    fullwidth={fullwidth}
    smallPadding={smallPadding}
    className={className}
    target={target}
  >
    {children}
  </Button>
)
